import React from "react";
import { useFormContext } from "react-hook-form";
import { connect } from "react-redux";

import {
  HubHookFormMoldSelect,
  HubHookFormPartSelectV2,
} from "../../components";
import { setIsOpenDialog } from "../../redux";
import { ORDER_TYPE_OPTIONS, ORDER_TYPES } from "../../constants/orders";

import ItemDescriptionMaterial from "./ItemDescriptionMaterial";
import { StyledAddMoldButton, StyledMoldPicker } from "./styles";

const ItemDescriptionField = ({
  prefix,
  _setIsOpenDialog = () => {},
  disabled,
}) => {
  const { watch, getValues } = useFormContext();

  const type = watch("type") || ORDER_TYPES.MATERIALS;
  const orderType = ORDER_TYPE_OPTIONS.find(({ id }) => id === type);

  const onEditMold = () => {
    const moldPartId = getValues(`${prefix}.partId`);
    if (moldPartId) _setIsOpenDialog("manage-mold", moldPartId);
  };

  if (orderType.id === ORDER_TYPES.MOLD) {
    return (
      <StyledMoldPicker>
        <HubHookFormMoldSelect
          name={`${prefix}.partId`}
          disabled={disabled}
          label={null}
          required
        />
        <StyledAddMoldButton
          className="AddMoldButton"
          label="Edit Mold"
          onClick={onEditMold}
          variant="text"
          size="xsmall"
          color="neutral"
        />
      </StyledMoldPicker>
    );
  }

  if (orderType.id === ORDER_TYPES.MATERIALS)
    return <ItemDescriptionMaterial prefix={prefix} disabled={disabled} />;

  if (orderType.id === ORDER_TYPES.PROCESSING)
    return (
      <HubHookFormPartSelectV2
        name={`${prefix}.partId`}
        formControlProps={{ className: "LineItemDescription" }}
        disabled={disabled}
        label={null}
        required
      />
    );

  return (
    <HubHookFormPartSelectV2
      name={`${prefix}.partId`}
      formControlProps={{ className: "LineItemDescription" }}
      disabled={disabled}
      label={null}
      required
    />
  );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
  _setIsOpenDialog: setIsOpenDialog,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemDescriptionField);
